import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ClockIconV3,
  CalendarIcon,
  PersonIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "../../../images/icons/icons";
import { fetchTaskDetailsData } from "../../../redux/hygiene-reducers/hygieneSlice";
import Loader from "../../ui/Loader";
import {
  convertStraight,
  convertTo12HourFormat,
} from "../../common-data/Converts";

const TaskDetailModal = ({ userInfoData, rowData, gymData, closeModal }) => {
  const dispatch = useDispatch();
  const { taskDetails, taskDetailsLoading, taskDetailsError } = useSelector(
    (state) => state.hygiene
  );

  const getStatusIcon = (status) => {
    const upperStatus = status?.toUpperCase();
    if (upperStatus === "COMPLETED") return <CheckCircleIcon />;
    if (upperStatus === "MISSED") return <XCircleIcon />;
    return <ClockIconV3 color="#F59E0B" />;
  };

  const getStatusClass = (status) => {
    const upperStatus = status?.toUpperCase();
    if (upperStatus === "COMPLETED") return "tb-badge tb-badge-success";
    if (upperStatus === "PENDING") return "tb-badge tb-badge-stuck";
    if (upperStatus === "MISSED") return "tb-badge not-assigned";
    return "tb-badge";
  };

  useEffect(() => {
    if (rowData?.task_id) {
      const filters = {
        task_id: rowData.task_id,
      };
      dispatch(
        fetchTaskDetailsData({
          filters: filters,
          token: userInfoData?.token,
        })
      );
    }
  }, [rowData?.task_id, userInfoData?.token, dispatch]);

  const taskInfo = taskDetails?.data?.task_information;
  const gymInfo = taskDetails?.data?.gym_information;

  return (
    <div className="hcc-modal-content">
      <div className="hcc-modal-header">
        <h2 className="hcc-modal-title">Task Information</h2>
        <button className="hcc-modal-close" onClick={closeModal}>
          Close
        </button>
      </div>

      <div className="hcc-modal-body">
        {taskDetailsLoading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <Loader />
          </div>
        ) : taskDetailsError ? (
          <div
            style={{ textAlign: "center", padding: "40px", color: "#dc3545" }}
          >
            Error loading task details: {taskDetailsError}
          </div>
        ) : (
          <>
            <div className="hcc-modal-section">
              <h3 className="hcc-modal-section-title">Task Information</h3>
              <div className="hcc-modal-info-grid">
                <div className="hcc-modal-info-row">
                  <div className="hcc-modal-info-label">
                    <PersonIcon />
                    <span>Task Name:</span>
                  </div>
                  <div className="hcc-modal-info-value">
                    {taskInfo?.task_name || "NA"}
                  </div>
                </div>

                <div className="hcc-modal-info-row">
                  <div className="hcc-modal-info-label">
                    <span>Category:</span>
                  </div>
                  <div className="hcc-modal-info-value">
                    {taskInfo?.category || "NA"}
                  </div>
                </div>

                <div className="hcc-modal-info-row">
                  <div className="hcc-modal-info-label">
                    <span>Priority:</span>
                  </div>
                  <div className="hcc-modal-info-value">
                    {taskInfo?.priority || "NA"}
                  </div>
                </div>
              </div>
            </div>

            <div className="hcc-modal-section">
              <h3 className="hcc-modal-section-title">Gym Information</h3>
              <div className="hcc-modal-info-grid">
                <div className="hcc-modal-info-row">
                  <div className="hcc-modal-info-label">
                    <PersonIcon />
                    <span>Gym Name:</span>
                  </div>
                  <div className="hcc-modal-info-value">
                    {gymInfo?.gym_name || "NA"}
                  </div>
                </div>

                <div className="hcc-modal-info-row">
                  <div className="hcc-modal-info-label">
                    <span>Gym Address:</span>
                  </div>
                  <div className="hcc-modal-info-value">
                    {gymInfo?.gym_address || "NA"}
                  </div>
                </div>

                <div className="hcc-modal-info-row">
                  <div className="hcc-modal-info-label">
                    {getStatusIcon(gymInfo?.status)}
                    <span>Status:</span>
                  </div>
                  <div className="hcc-modal-info-value">
                    <span
                      className={getStatusClass(gymInfo?.status)}
                      style={{ fontSize: "13px" }}
                    >
                      {gymInfo?.status || "NA"}
                    </span>
                  </div>
                </div>

                <div className="hcc-modal-info-row">
                  <div className="hcc-modal-info-label">
                    <CalendarIcon color="#2c3e50" />
                    <span>Date:</span>
                  </div>
                  <div className="hcc-modal-info-value">
                    {gymInfo?.date ? convertStraight(gymInfo.date) : "NA"}
                  </div>
                </div>

                <div className="hcc-modal-info-row">
                  <div className="hcc-modal-info-label">
                    <ClockIconV3 color="#2c3e50" />
                    <span>Time:</span>
                  </div>
                  <div className="hcc-modal-info-value">
                    {gymInfo?.start_time && gymInfo?.end_time
                      ? `${convertTo12HourFormat(
                          gymInfo.start_time
                        )} - ${convertTo12HourFormat(gymInfo.end_time)}`
                      : "NA"}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TaskDetailModal;
